(function () {
  if (!window.jQuery) return;
  var $ = window.jQuery;

  var STORAGE_KEY = "bg_wishlist_v1";

  function safeParse(v, fallback) { try { return JSON.parse(v) || fallback; } catch (e) { return fallback; } }
  function getList() { return safeParse(localStorage.getItem(STORAGE_KEY), []); }
  function setList(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
  function exists(id) { id = String(id); return getList().some(function (x) { return String(x.id) === id; }); }

  function upsert(item) {
    var list = getList();
    var id = String(item.id || "");
    if (!id) return list;
    list = list.filter(function (x) { return String(x.id) !== id; });
    list.unshift(item);
    setList(list);
    return list;
  }

  function remove(id) {
    id = String(id);
    var list = getList().filter(function (x) { return String(x.id) !== id; });
    setList(list);
    return list;
  }

  function isProductPage() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
        if (String(window.ShopifyAnalytics.meta.page.pageType || "").toLowerCase() === "product") return true;
      }
    } catch (e) {}

    if (document.body && document.body.classList) {
      if (document.body.classList.contains("template-product")) return true;
      if (/template-product/i.test(document.body.className || "")) return true;
    }

    try {
      var path = (location.pathname || "").toLowerCase();
      if (path.indexOf("/products/") === 0) return true;
    } catch (e) {}

    return false;
  }

  function getCurrentHandleFromURL() {
    var path = (location.pathname || "");
    var m = path.match(/\/products\/([^\/\?]+)/i);
    return m ? m[1] : "";
  }

  function stripTooltipHooks($btn) {
    if (!$btn || !$btn.length) return;
    $btn.removeAttr("data-tooltip")
      .removeAttr("title")
      .removeAttr("aria-label")
      .removeAttr("data-bg-wl-tip")
      .removeAttr("data-tippy-content");
  }

  function headerCount() {
    var count = getList().length;
    $(".bg-wl-badge--header[data-bg-wl-count]").each(function () {
      if (count > 0) $(this).text(String(count)).show();
      else $(this).text("").hide();
    });
  }

  function syncButtons() {
    $("[data-bg-wl-btn]").each(function () {
      var $btn = $(this);
      var id = $btn.attr("data-product-id");
      if (!id) return;

      stripTooltipHooks($btn);

      var active = exists(id);
      $btn.attr("data-active", active ? "true" : "false");
      $btn.attr("aria-pressed", active ? "true" : "false");
    });
  }

  function fetchProductByHandle(handle) {
    return $.ajax({
      url: "/products/" + encodeURIComponent(handle) + ".js",
      method: "GET",
      dataType: "json",
      cache: true
    });
  }

  function moneyFormat(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        var fmt = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : "${{amount}}";
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function buildItemFromProductJson(prod) {
    var img = (prod && prod.images && prod.images.length) ? prod.images[0] : "";
    var priceCents = (prod && typeof prod.price === "number") ? prod.price : 0;

    return {
      id: String(prod.id || ""),
      handle: String(prod.handle || ""),
      url: "/products/" + String(prod.handle || ""),
      title: String(prod.title || ""),
      image: String(img || ""),
      price: moneyFormat(priceCents)
    };
  }

  function addViaAjax($btn) {
    var handle = $btn.attr("data-product-handle") || "";
    var url = $btn.attr("data-product-url") || "";
    if (!handle) return $.Deferred().reject().promise();

    return fetchProductByHandle(handle).then(function (prod) {
      var item = buildItemFromProductJson(prod);
      if (url) item.url = url;
      upsert(item);
      return item;
    });
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderDrawer() {
    var $list = $("#BG_WL_LIST");
    var $empty = $("#BG_WL_EMPTY");
    if (!$list.length || !$empty.length) return;

    var list = getList();
    if (!list.length) {
      $empty.show();
      $list.html("");
      return;
    }

    $empty.hide();

    var html = list.map(function (item) {
      var title = escapeHtml(item.title);
      var img = item.image ? '<img src="' + item.image + '" alt="' + title + '" loading="lazy">' : "";
      var url = item.url || "#";
      var price = escapeHtml(item.price || "");

      return (
        '<div class="bg-wl-row">' +
          '<a class="bg-wl-row__img" href="' + url + '">' + img + '</a>' +
          '<div class="bg-wl-row__info">' +
            '<a class="bg-wl-row__title" href="' + url + '">' + title + '</a>' +
            '<div class="bg-wl-row__price">' + price + '</div>' +
          '</div>' +
          '<div class="bg-wl-row__actions">' +
            '<button type="button" class="bg-wl-mini-btn" data-bg-wl-remove="' + item.id + '">REMOVE</button>' +
          '</div>' +
        '</div>'
      );
    }).join("");

    $list.html(html);
  }

  function purgeNonProductHearts() {
    if (isProductPage()) return;
    $("[data-bg-wl-btn]").remove();
    $(".bg-wl-btn").remove();
  }

  function ensureProductOverlayOnce() {
    if (!isProductPage()) return;
    if ($("[data-bg-wl-btn]").length) return;

    var handle = getCurrentHandleFromURL();
    if (!handle) return;

    var $target =
      $(".product__media-list, .product__media, .product-media, .product-gallery, .product__gallery").first();

    if (!$target.length) $target = $(".product").first();
    if (!$target.length) return;

    if ($target.css("position") === "static") $target.css("position", "relative");

    fetchProductByHandle(handle).done(function (prod) {
      if ($("[data-bg-wl-btn]").length) return;
      var item = buildItemFromProductJson(prod);

      var $btn = $(
        '<button type="button" class="bg-wl-btn" data-bg-wl-btn aria-pressed="false" data-active="false">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path d="M12 20.7l-1.2-1.1C6.1 15.4 3 12.6 3 9.3 3 6.9 4.9 5 7.3 5c1.5 0 3 .8 3.7 2h2c.7-1.2 2.2-2 3.7-2C19.1 5 21 6.9 21 9.3c0 3.3-3.1 6.1-7.8 10.3L12 20.7z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>'
      );

      $btn.attr("data-product-id", item.id);
      $btn.attr("data-product-handle", item.handle);
      $btn.attr("data-product-url", item.url);
      $btn.attr("data-product-title", item.title);
      $btn.attr("data-product-image", item.image);
      $btn.attr("data-product-price", item.price);

      stripTooltipHooks($btn);

      $btn.css({
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 50
      });

      $target.append($btn);

      syncButtons();
      headerCount();
    });
  }

  /* ===== Drawer controller — unchanged logic ===== */
  var drawer = {
    $el: null,
    isOpen: false,
    lastFocus: null,

    open: function (triggerEl) {
      if (!this.$el || !this.$el.length) return;
      this.lastFocus = triggerEl || document.activeElement;

      this.$el.prop("hidden", false).attr("aria-hidden", "false").addClass("is-open");
      this.isOpen = true;

      document.documentElement.style.overflow = "hidden";
      $("[data-bg-wl-open]").attr("aria-expanded", "true");
      renderDrawer();
    },

    close: function () {
      if (!this.$el || !this.$el.length) return;
      this.$el.attr("aria-hidden", "true").removeClass("is-open");
      this.isOpen = false;

      $("[data-bg-wl-open]").attr("aria-expanded", "false");
      document.documentElement.style.overflow = "";

      var self = this;
      window.setTimeout(function () {
        if (!self.isOpen) self.$el.prop("hidden", true);
      }, 220);

      if (this.lastFocus && typeof this.lastFocus.focus === "function") {
        this.lastFocus.focus();
      }
    }
  };

  function init() {
    try {
      drawer.$el = $("#bg-wishlist-drawer");

      purgeNonProductHearts();
      ensureProductOverlayOnce();

      headerCount();
      syncButtons();
      renderDrawer();

      if (isProductPage()) {
        var tries = 0;
        var t = window.setInterval(function () {
          tries++;
          ensureProductOverlayOnce();
          syncButtons();
          if ($("[data-bg-wl-btn]").length || tries >= 12) window.clearInterval(t);
        }, 400);
      }

      /* ===== header / drawer logic unchanged ===== */
      $(document).on("click", "[data-bg-wl-open]", function (e) {
        e.preventDefault();
        drawer.open(this);
      });

      $(document).on("click", "[data-bg-wl-close]", function (e) {
        e.preventDefault();
        drawer.close();
      });

      $(document).on("keydown", function (e) {
        if (e.key === "Escape" && drawer.isOpen) drawer.close();
      });

      $(document).on("click", "[data-bg-wl-remove]", function (e) {
        e.preventDefault();
        remove($(this).attr("data-bg-wl-remove"));
        syncButtons();
        headerCount();
        renderDrawer();
      });

      $(document).on("click", "[data-bg-wl-clear]", function (e) {
        e.preventDefault();
        setList([]);
        syncButtons();
        headerCount();
        renderDrawer();
      });

      /* ===== tooltip events removed only ===== */

      $(document).on("click", "[data-bg-wl-btn]", function (e) {
        if (!isProductPage()) return;

        e.preventDefault();
        e.stopPropagation();

        var $btn = $(this);
        if ($btn.data("bgBusy")) return;
        $btn.data("bgBusy", true);

        stripTooltipHooks($btn);

        var id = $btn.attr("data-product-id");

        if (exists(id)) {
          remove(id);
          syncButtons();
          headerCount();
          renderDrawer();
          $btn.data("bgBusy", false);
          return;
        }

        addViaAjax($btn).done(function () {
          syncButtons();
          headerCount();
          renderDrawer();
        }).fail(function () {
          try { console.error("[BG Wishlist] add failed"); } catch (e) {}
        }).always(function () {
          $btn.data("bgBusy", false);
        });
      });

      document.addEventListener("shopify:section:load", function () {
        purgeNonProductHearts();
        ensureProductOverlayOnce();
        syncButtons();
        headerCount();
      });

      window.addEventListener("storage", function (e) {
        if (e.key === STORAGE_KEY) {
          headerCount();
          syncButtons();
          if (drawer.isOpen) renderDrawer();
        }
      });
    } catch (err) {
      try { console.error("[BG Wishlist] init error", err); } catch(e) {}
    }
  }

  $(init);
})();